export default "__VITE_ASSET__bfc8a6fe__"